<fuse-widget class="widget h-360 p-0 mb-16" fxLayout="row" fxFlex="100" fxFlex.gt-sm="100" *ngIf="!isLoading">
  <div class="fuse-widget-front">
    <div class="p-20 h-59" fxLayout="row" fxLayoutAlign="space-between center">
      <div class="font-size-16 secondary-text">
        {{ title }}
      </div>
    </div>

    <div class="my-12 mx-8 h-75-p" fxLayout="row" fxLayoutAlign="center center">
      <ngx-charts-line-chart
        *ngIf="!isLoading && results[0]?.series?.length"
        class="h-100-p"
        (select)="select.emit($event)"
        [view]="view"
        [scheme]="scheme"
        [roundDomains]="true"
        [results]="results"
        [xAxis]="xAxis"
        [yAxis]="yAxis"
        [yScaleMax]="yScaleMax"
        [yScaleMin]="yScaleMin"
        [yAxisTickFormatting]="yAxisTickFormatting"
        [autoScale]="autoScale"
      >
        <ng-container *ngIf="isDateFormat">
          <ng-template #tooltipTemplate let-model="model">
            <div class="tooltip-text">
              <pre>{{ model.formattedName }}: {{ model.value }}</pre>
              <pre *ngIf="model.totalCount != null">({{ model.totalCount }})</pre>
            </div>
          </ng-template>

          <ng-template #seriesTooltipTemplate let-model="model">
            <div class="tooltip-text">
              <pre>{{ model[0].formattedName }}: {{ model[0].value }}</pre>
              <pre *ngIf="model[0].totalCount != null">({{ model[0].totalCount }})</pre>
            </div>
          </ng-template>
        </ng-container>
      </ngx-charts-line-chart>

      <p class="pie-chart-report__no-results" *ngIf="!isLoading && !results[0]?.series?.length">
        {{ 'LINE_CHART.NO_DATA' | translate }}
      </p>
    </div>
  </div>
</fuse-widget>

<!-- SKELETON-LOADER -->

<fuse-widget class="widget h-360 p-0 mb-16" fxLayout="row" fxFlex="100" fxFlex.gt-sm="100" *ngIf="isLoading">
  <div class="fuse-widget-front">
    <div class="p-20 h-59" fxLayout="row" fxLayoutAlign="space-between center">
      <div class="font-size-16 secondary-text">
        <ngx-skeleton-loader
          [theme]="{ height: '18px', width: '150px', 'margin-bottom': '0px', 'margin-left': '0px' }"
        ></ngx-skeleton-loader>
      </div>
    </div>

    <div class="my-12 mx-8 h-100-p" fxLayout="row" fxLayoutAlign="center center">
      <ngx-skeleton-loader
        [theme]="{ height: '250px', width: '700px', 'margin-bottom': '0px', 'margin-left': '0px' }"
      ></ngx-skeleton-loader>
    </div>
  </div>
</fuse-widget>

<!-- /SKELETON-LOADER -->
